import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import moment from 'moment';
import useFormValidator from 'useFormValidator';
import DateInputPicker3 from 'modules/common/components/DateInputPicker3';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';
import * as c from '../constant';

function CreateModal({
  createOrdinanceRevision,
  getOrdinanceRevisionList,
  history,
  getSingleOrdinanceRevision,
  creating,
}) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    year_from: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    year_from: 'required',
  });

  const setModal = useContext(ModalContext);

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
      year_from: moment(_.get(formData, 'year_from')).format('YYYY'),
    };

    createOrdinanceRevision(args, ({ data }) => {
      setModal({ isOpen: false });
      getOrdinanceRevisionList();
      history.push(`/bpls/settings/ordinance-revision/${_.get(data, 'id')}`);
      getSingleOrdinanceRevision(data.id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangeYear = key => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const maxYearPicker = new Date().getFullYear() + 5;
  const maxYear = new Date(maxYearPicker, 12, 1);

  const minYearPicker = new Date().getFullYear() - 1;
  const minYear = new Date(minYearPicker, 12, 1);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Name: {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description:
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Year From: {validateForm.renderMessage('year_from')}
            </label>
            <DateInputPicker3
              showYearPicker
              onChange={onChangeYear('year_from')}
              className="form-control"
              value={_.get(formData, 'year_from') || ''}
              placeholder="Select Year..."
              defaultShow={false}
              minDate={minYear}
              maxDate={maxYear}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={creating || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {creating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>{' '}
          </button>
          <button
            disabled={creating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  createOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  creating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  creating: api.loading.indexOf(c.CREATE_ORDINANCE_REVISION) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
